export const menuItems = [
  {
    id: 1,
    label: "",
    isTitle: true,
    userTypes: ["super_admin", "old_admin", "employee"],
  },

  // Super admin items
  {
    id: 10001,
    label: "Firme",
    icon: "fas fa-address-book",
    link: "/super-admin/administrators",
    parentId: 1,
    userTypes: ["super_admin"],
  },
  {
    id: 10002,
    label: "Grupe",
    icon: "fas fa-user-friends",
    link: "/super-admin/groups",
    parentId: 1,
    userTypes: ["super_admin"],
  },
  {
    id: 10003,
    label: "Objekti",
    icon: "fas fa-id-badge",
    link: "/super-admin/employees",
    parentId: 1,
    userTypes: ["super_admin"],
  },
  {
    id: 10004,
    label: "Porudžbenice",
    icon: "fas fa-shopping-cart",
    link: "/super-admin/order-form-items",
    parentId: 1,
    userTypes: ["super_admin"],
  },
  {
    id: 10005,
    label: "Zamenski artikli",
    icon: "fas fa-retweet",
    link: "/super-admin/replacement-items",
    parentId: 1,
    userTypes: ["super_admin"],
  },
  {
    id: 10006,
    label: "Limiti",
    icon: "fas fa-book",
    link: "/super-admin/limits",
    parentId: 1,
    userTypes: ["super_admin"],
  },
  {
    id: 10007,
    label: "Budžeti",
    icon: "fas fa-wallet",
    link: "/super-admin/employee-budgets",
    parentId: 1,
    userTypes: ["super_admin"],
  },
  {
    id: 10008,
    label: "Uputstva",
    icon: "fas fa-book-open",
    link: "/super-admin/manuals",
    parentId: 1,
    userTypes: ["super_admin"],
  },
  {
    id: 10009,
    label: "Ariba",
    icon: "fas fa-link",
    link: "/super-admin/ariba/sessions",
    parentId: 1,
    userTypes: ["super_admin"],
  },
  // {
  //   id: 10010,
  //   label: "City Express",
  //   icon: "fas fa-shipping-fast",
  //   link: "/super-admin/cityexpress",
  //   parentId: 1,
  //   userTypes: ["super_admin"],
  // },
  {
    id: 10011,
    label: "City Express",
    icon: "fas fa-shipping-fast",
    link: "/super-admin/city-express",
    parentId: 1,
    userTypes: ["super_admin"],
    cityExpress: true,
  },
  {
    id: 20001,
    label: "Porudžbenice",
    icon: "fas fa-shopping-cart",
    link: "/admin/order-form-items",
    parentId: 1,
    userTypes: ["admin"],
  },
  {
    id: 20002,
    label: "Porudžbenice Objekta",
    icon: "fas fa-book",
    link: "/admin/employee-order-forms",
    parentId: 1,
    userTypes: ["admin"],
  },
  {
    id: 20003,
    label: "Limiti",
    icon: "fas fa-book",
    link: "/admin/limits",
    parentId: 1,
    userTypes: ["admin"],
  },
  {
    id: 20004,
    label: "Budžeti",
    icon: "fas fa-wallet",
    link: "/admin/employee-budgets",
    parentId: 1,
    userTypes: ["admin"],
  },
  {
    id: 20005,
    label: "Grupe",
    icon: "fas fa-user-friends",
    link: "/admin/groups",
    parentId: 1,
    userTypes: ["admin"],
  },
  {
    id: 20006,
    label: "Uputstvo",
    icon: "fas fa-book-open",
    link: "manual",
    parentId: 1,
    userTypes: ["admin"],
    externalLink: true,
  },
  {
    id: 30001,
    label: "Porudžbenice",
    icon: "fas fa-book",
    link: "/employee/order-form",
    parentId: 1,
    userTypes: ["employee"],
  },
  {
    id: 30002,
    label: "Uputstvo",
    icon: "fas fa-book-open",
    link: "manual",
    parentId: 1,
    userTypes: ["employee"],
    externalLink: true,
  },
  {
    id: 40001,
    label: "Ariba Shop",
    icon: "fas fa-book",
    parentId: 1,
    userTypes: ["ariba"],
  },
];
